<script>
	export let data;
	export let { issue, articles } = data;
	// Helper function to format author names
	function formatAuthors(authors) {
		// if authors is null or empty, return empty string
		if (!authors || !authors.length) return '';
		return authors
			.map((author) =>
				[
					author.first_name,
					author.middle_name, // Assuming middle_name can be null or empty
					author.last_name
				]
					.filter(Boolean)
					.join(' ')
			)
			.join(', ');
	}
	// console.log(issue);
</script>

<div class="px-6 py-8 lg:py-20 lg:px-8">
	<div class="max-w-6xl mx-auto text-base leading-7">
		<div class="container p-4 mx-auto">
			<h1 class="text-2xl font-bold">{issue.title} ({issue.year})</h1>
			<p class="text-gray-600">{issue.description}</p>

			<div class="mt-6">
				<h2 class="text-xl font-semibold">Articles</h2>
				<ul role="list" class="divide-y divide-gray-100">
					{#each articles as article (article.id)}
						{#if !article.draft}
							<li class="flex items-center justify-between py-5 gap-x-6">
								<div class="min-w-0">
									<div class="flex items-start gap-x-3">
										<a href="/article/{article.id}">
											<p class="text-sm font-semibold leading-6 text-blue-900 hover:underline">
												{article.title}
											</p>
										</a>
										<!-- Optionally display additional article metadata here -->
									</div>
									<div class="flex items-center mt-1 text-xs leading-5 text-gray-500 gap-x-2">
										<p class="truncate">{formatAuthors(article.authors)}</p>
										<!-- Other article metadata like publication date, etc. -->
									</div>
								</div>
								<div class="flex items-center flex-none gap-x-4">
									<a
										href="/article/{article.id}"
										class="rounded-md bg-white px-2.5 py-1.5 text-sm text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
										>Open Article</a
									>
									<!-- Add other buttons or dropdowns as needed -->
								</div>
							</li>
						{/if}
					{/each}
				</ul>
			</div>
		</div>
	</div>
</div>

<style>
	/* Add custom styles here */
</style>
